module.exports = __webpack_public_path__ + "/img/SOT143-Labeled-FfMK19.svg";